import React from 'react';
import { DueDate, LightBulbSection, Recalculate } from './styled';
import { getFormattedDate } from '../utils';
import { useRouter } from 'next/router';
import { images } from '../../../../Constants/ImageUrls';

function ShowResults(props) {
  const { dueDate, setDueDate } = props;
  const date = getFormattedDate(dueDate);
  const router = useRouter();

  return (
    <DueDate>
      <h3>Your Due Date is: </h3>
      <p>{date}</p>
      <LightBulbSection>
        <img src="/images/lightbox.png" alt="" width="30px" height="30px" />
        <p>
          Did you know that less than <strong>5%</strong> of women deliver on
          their due date!
        </p>
      </LightBulbSection>
      <Recalculate
        Recalculate
        onClick={() => {
          setDueDate(null);
          router.back();
        }}
      >
        <img
          src={images.refreshIcon}
          alt="refresh icon"
          width="20px"
          height="20px"
        />
        &nbsp;Recalculate your due date
      </Recalculate>
    </DueDate>
  );
}

export default ShowResults;
